module.exports = function (componentName) {
	'use strict';

	if (__BASE_DESIGN__ === 'skin_autumn_frame_new') {
		return require('../skin/autumnNew/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_base2_frame') {
		return require('../skin/base2/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_infinity_frame') {
		return require('../skin/infinity/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_passion_frame') {
		return require('../skin/passion/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_princess_frame') {
		return require('../skin/princess/frame/components/' + componentName + '/index');
	} else if (__BASE_DESIGN__ === 'skin_liberty_frame') {
		return require('../skin/liberty/frame/components/' + componentName + '/index');
	}
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/utils/get-skin-component.js
// module id = 79
// module chunks = 4